export default {
  data() {
    return {
      errorCounter: 0
    };
  },

  provide() {
    return {
      incrementErrorCounter: this.incrementErrorCounter.bind(this),
    };
  },

  updated() {
    //console.log("Visiting");
    const filter = comp =>
      comp.$options.name && comp.$options.name.endsWith("-form-field");
    const consumer = (indent, comp) => {
      //console.log(indent, "WOW");
      if (comp.error) {
        this.incrementErrorCounter();
      }
    };

    this.visit("", this, filter, consumer);
  },

  methods: {
    resetErrorCounter() {
      //console.log("Resetting counter");
      this.errorCounter = 0;
    },

    incrementErrorCounter() {
      this.errorCounter++;
    },

    visit(indent, comp, filter, consumer) {
      //console.log(indent, comp.$options.name, comp);
      if (filter(comp)) {
        consumer(indent, comp);
      }
      for (let c of comp.$children) {
        this.visit(indent + "  ", c, filter, consumer);
      }
    }
  }
};
